import { Component, OnInit, ElementRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityServiceForMedicalService } from '../../../services/utility-service';
import { Store } from '@ngrx/store';
import { HealthService } from 'src/app/core/cms/health/health.service';
import { AppState } from '../../../../../store/state/app.state';
import { QuoteDataCaptureService, UtilService, SERVICE_END_POINT, AuthService } from 'src/app/shared';
import * as UserDataConfig from '../../../../user-details/config/user-data.config';
import { SyncService } from '../../../services/sync.service';
import { Subscription } from 'rxjs';
import { Sections, HealthLifestyle } from '../../../model';
import { MEDICAL_UW_URL, MEDICAL_UW_HO_URL } from 'src/app/shared/constants/medical-uw-url.constants';
import { BackDataStoreModel, EditMedIndexModel } from 'src/app/pages/medical-underwriting/model/mcUserJourney.model';
import { AnalyticsService } from 'src/app/shared';

@Component({
  selector: 'app-diabetes',
  templateUrl: './diabetes.component.html',
  styleUrls: ['./diabetes.component.scss']
})
export class DiabetesComponent implements OnInit, OnDestroy {

  contentData: any;
  displayPage = true;
  public diabetesForm: UntypedFormGroup;
  public userInputDetail = UserDataConfig.ElementsConfig;
  protected initialQuesSubscription: Subscription;
  private initialQuestionJson: string;
  private mcUserJourneyJson: any;
  public selectedTitle: string;
  private mcLength: number;
  isHOView = false;
  private isEditMode: boolean;
  private currentMedIndex: number;
  private CMSData;
  private subscripBeforeLogin: Subscription;
  private subscripSaveProgress: Subscription;
  private subscripLogout: Subscription;
  private imageURl: string;
  public showBackBtn: boolean;

  constructor(private fb: UntypedFormBuilder, private activatedRoute: ActivatedRoute,
              private router: Router,
              public el: ElementRef,
              private utilityServiceForMedicalService: UtilityServiceForMedicalService,
              private store: Store<AppState>,
              private healthService: HealthService,
              private syncService: SyncService,
              private quoteDatacaptureService: QuoteDataCaptureService,
              private utilService: UtilService,
              private analyticsService:AnalyticsService, private authService: AuthService) {
    this.activatedRoute.snapshot.data.contentData.diabetes.details = this.getDefaultValues();
    this.contentData = this.activatedRoute.snapshot.data.contentData.diabetes;

    this.syncService.getInitialQuestionJson().subscribe((res) => {
      this.initialQuestionJson = res.jsonUrl;
      this.selectedTitle = res.tittle;
      console.log("initialQuestionJson Getter=>", this.initialQuestionJson);
    });
    this.isHOView = this.router.url.includes('ho-underwriting') ? true : false;

    this.syncService.getEditMode().subscribe(res => {
      this.showBackBtn = (res === true) ?  false : true;
    });

    this.syncService.getBackNavData().subscribe(res => {
      this.isEditMode = res.isEdit;
      this.currentMedIndex = res.currentIndex;
    });
  }

  ngOnInit() {
    this.GetCMSDataServiceMapper(); /** TODO: To be done in phase 2, mapper ready, but logic has to be written wrt each medical conditions */
    this.diabetesForm = this.fb.group({

    });
    this.subscripBeforeLogin = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLoginFunction.subscribe(() => {
      this.saveAfterLogin();
    });
    this.subscripSaveProgress = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    this.subscripLogout = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();

    });
  }

  ngOnDestroy() {
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripBeforeLogin) {
      this.subscripBeforeLogin.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
  }

  saveAfterLogin() {
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res =>
      this.utilService.afterSaveSuccesfully()
    );
  }
  saveAfterLogout() {
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  saveProgress() {
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe();
  }

  closePage() {
    this.displayPage = false;
    if (this.isHOView) {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.medicalConditions, MEDICAL_UW_HO_URL.dependant.dependantMedicalConditions)]);
    } else {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_URL.annuitant.medicalConditions, MEDICAL_UW_URL.dependant.dependantMedicalConditions)]);
    }
    // this.router.navigate(['/home/medical-conditions']);
  }

  gotoNext = () => {
    if (this.isHOView) {
      if (this.isEditMode && this.currentMedIndex) {
        let tempIndex: number = this.currentMedIndex;
        const tempEditMedIndexModelObj = new EditMedIndexModel();
        tempEditMedIndexModelObj.editIndex = tempIndex;
        this.syncService.setEditMedConditionIndex(tempEditMedIndexModelObj);
        this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.DMC, MEDICAL_UW_HO_URL.dependant.dependantDMC)]);
      } else {
        // tslint:disable-next-line: max-line-length
        this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.DMC, MEDICAL_UW_HO_URL.dependant.dependantDMC)]);
      }
    } else {
      if (this.isEditMode && this.currentMedIndex) {
        let tempIndex: number = this.currentMedIndex;
        const tempEditMedIndexModelObj = new EditMedIndexModel();
        tempEditMedIndexModelObj.editIndex = tempIndex;
        this.syncService.setEditMedConditionIndex(tempEditMedIndexModelObj);
        this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_URL.annuitant.DMC, MEDICAL_UW_URL.dependant.dependantDMC)]);
      } else {
        // tslint:disable-next-line: max-line-length
        this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_URL.annuitant.DMC, MEDICAL_UW_URL.dependant.dependantDMC)]);
      }
    }
    // this.router.navigate(['/home/medical-condition-questionnaire']);
  }
  
  /** Code block for CMS */
  GetCMSDataServiceMapper() {
    ////console.log('original value = ', this.contentData.details.find(ele => ele["noteStatement"] === "Optional but may be worthwhile:").textDetails[0].text);
    //console.log('selectedTitle value=', this.selectedTitle);
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_MedicalConditionBeforeYouStart;
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the healthData object values with CMSData object values */
        this.contentData.introduction = this.CMSData.string_MedicalConditionBeforeYouStartSubtitle;
        this.contentData.details[0].noteStatement = this.CMSData.string_MedicalConditionBeforeYouStartsInformationNeededTitle;
        this.contentData.details[1].noteStatement = this.CMSData.string_MedicalConditionBeforeYouStartsInformationOptionalTitle;
        /** Conditions for checking the medical conditions , for the appropriate contents to be mapped */
        /** Diabetes Content Mapper*/
        // this.imageURl = this.CMSData.commonBlock.;
        if (this.selectedTitle.trim() === 'Diabetes') {
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[0].text = this.CMSData.string_DiabetesInformationNeededItem_1;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[1].text = this.CMSData.string_DiabetesInformationNeededItem_2;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[2].text = this.CMSData.string_DiabetesInformationNeededItem_3;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[0].text = this.CMSData.string_DiabetesInformationOptionalItem_1;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[1].text = this.CMSData.string_DiabetesInformationOptionalItem_2;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[2].text = this.CMSData.string_DiabetesInformationOptionalItem_3;
          this.contentData.checkList.url = this.CMSData.externalUrl_DiabetesRequirementChecklist;
          this.contentData.checkList.name = this.selectedTitle.trim() + ' Requirements Checklist';
        }

        /** High blood pressure Content Mapper */
        if (this.selectedTitle.trim() === 'High blood pressure') {
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[0].text = this.CMSData.string_HighBPInformationNeededItem_1;

          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[0].text = this.CMSData.string_HighBPInformationOptionalItem_1;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[1].text = this.CMSData.string_HighBPInformationOptionalItem_2;
          this.contentData.checkList.url = this.CMSData.externalUrl_HighBPRequirementChecklist;
          this.contentData.checkList.name = this.selectedTitle.trim() + ' Requirements Checklist';
        }
        /** Heart disease Content Mapper */
        if (this.selectedTitle.trim() === 'Heart disease') {
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[0].text = this.CMSData.string_HeartInformationNeededItem_1;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[1].text = this.CMSData.string_HeartInformationNeededItem_2;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[2].text = this.CMSData.string_HeartInformationNeededItem_3;

          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[0].text = this.CMSData.string_HeartInformationOptionalItem_1;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[1].text = this.CMSData.string_HeartInformationOptionalItem_2;
          this.contentData.checkList.url = this.CMSData.externalUrl_HeartDiseaseRequirementChecklist;
          this.contentData.checkList.name = this.selectedTitle.trim() + ' Requirements Checklist';
        }
        /** High cholesterol Content Mapper */
        if (this.selectedTitle.trim() === 'High cholesterol') {
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[0].text = this.CMSData.string_CholesterolInformationNeededItem_1;

          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[0].text = this.CMSData.string_CholesterolInformationOptionalItem_1;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[1].text = this.CMSData.string_CholesterolInformationOptionalItem_2;
          this.contentData.checkList.url = this.CMSData.externalUrl_HighCholesterolRequirementChecklist;
          this.contentData.checkList.name = this.selectedTitle.trim() + ' Requirements Checklist';
        }
        /** Lung or respiratory disease Content Mapper */
        if (this.selectedTitle.trim() === 'Lung or respiratory disease') {
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[0].text = this.CMSData.string_LungRespiratoryInformationNeededItem_1;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[1].text = this.CMSData.string_LungRespiratoryInformationNeededItem_2;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[2].text = this.CMSData.string_LungRespiratoryInformationNeededItem_3;

          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[0].text = this.CMSData.string_LungRespiratoryInformationOptionalItem_1;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[1].text = this.CMSData.string_LungRespiratoryInformationOptionalItem_2;
          this.contentData.checkList.url = this.CMSData.externalUrl_LungRespiratoryDiseaseRequirementChecklist;
          this.contentData.checkList.name = this.selectedTitle.trim() + ' Requirements Checklist';
        }
        /** Neurological disease Content Mapper */
        if (this.selectedTitle.trim() === 'Neurological disease') {
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[0].text = this.CMSData.string_NeurologicalInformationNeededItem_1;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[1].text = this.CMSData.string_NeurologicalInformationNeededItem_2;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[2].text = this.CMSData.string_NeurologicalInformationNeededItem_3;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[3].text = this.CMSData.string_NeurologicalInformationNeededItem_4;

          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[0].text = this.CMSData.string_NeurologicalInformationOptionalItem_1;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[1].text = this.CMSData.string_NeurologicalInformationOptionalItem_2;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[2].text = this.CMSData.string_NeurologicalInformationOptionalItem_3;
          this.contentData.checkList.url = this.CMSData.externalUrl_NeurologicalRequirementChecklist;
          this.contentData.checkList.name = this.selectedTitle.trim() + ' Requirements Checklist';
        }
        /** Cancer Content Mapper */
        if (this.selectedTitle.trim() === 'Cancer') {
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[0].text = this.CMSData.string_CancerInformationNeededItem_1;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[1].text = this.CMSData.string_CancerInformationNeededItem_2;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[2].text = this.CMSData.string_CancerInformationNeededItem_3;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[3].text = this.CMSData.string_CancerInformationNeededItem_4;

          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[0].text = this.CMSData.string_CancerInformationOptionalItem_1;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[1].text = this.CMSData.string_CancerInformationOptionalItem_2;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[2].text = this.CMSData.string_CancerInformationOptionalItem_3;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[3].text = this.CMSData.string_CancerInformationOptionalItem_4;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[4].text = this.CMSData.string_CancerInformationOptionalItem_5;
          this.contentData.checkList.url = this.CMSData.externalUrl_CancerRequirementChecklist;
          this.contentData.checkList.name = this.selectedTitle.trim() + ' Requirements Checklist';
        }
        /** Stroke Content Mapper */
        if (this.selectedTitle.trim() === 'Stroke') {
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[0].text = this.CMSData.string_StrokeInformationNeededItem_1;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[1].text = this.CMSData.string_StrokeInformationNeededItem_2;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[2].text = this.CMSData.string_StrokeInformationNeededItem_3;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[3].text = this.CMSData.string_StrokeInformationNeededItem_4;

          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[0].text = this.CMSData.string_StrokeInformationOptionalItem_1;
          this.contentData.checkList.url = this.CMSData.externalUrl_StrokeRequirementChecklist;
          this.contentData.checkList.name = this.selectedTitle.trim() + ' Requirements Checklist';
        }
        /** Other medical conditions Content Mapper */
        if (this.selectedTitle.trim() === 'Multiple sclerosis') {
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[0].text = this.CMSData.string_MultipleSclerosisInformationNeededItem_1;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[1].text = this.CMSData.string_MultipleSclerosisInformationNeededItem_2;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[2].text = this.CMSData.string_MultipleSclerosisInformationNeededItem_3;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[3].text = this.CMSData.string_MultipleSclerosisInformationNeededItem_4;

          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[0].text = this.CMSData.string_MultipleSclerosisInformationOptionalItem_1;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[1].text = this.CMSData.string_MultipleSclerosisInformationOptionalItem_2;
          this.contentData.checkList.url = this.CMSData.externalUrl_MSRequirementChecklist;
          this.contentData.checkList.name = this.selectedTitle.trim() + ' Requirements Checklist';
        } 
        if (this.selectedTitle.trim() === 'Other medical conditions') {
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[0].text = this.CMSData.string_OtherMedicalConditionsInformationNeededItem_1;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[1].text = this.CMSData.string_OtherMedicalConditionsInformationNeededItem_2;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[0].noteStatement).textDetails[2].text = this.CMSData.string_OtherMedicalConditionsInformationNeededItem_3;

          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[0].text = this.CMSData.string_OtherMedicalConditionsInformationOptionalItem_1;
          this.contentData.details.find(ele => ele['noteStatement'] === this.contentData.details[1].noteStatement).textDetails[1].text = this.CMSData.string_OtherMedicalConditionsInformationOptionalItem_2;
          this.contentData.checkList.url = this.CMSData.externalUrl_OtherMedicalConditionsRequirementChecklist;
          this.contentData.checkList.name = this.selectedTitle.trim() + ' Requirements Checklist';
        }
        ////console.log('changed value = ', this.contentData.details.find(ele => ele['noteStatement'] === 'You’ll need:').textDetails[0].text);
        this.removeUnwantedDetailsFromContentData();
      }
    });


  }

  getDefaultValues() {
    return [
      {
        "noteStatement": "You’ll need:",
        "textDetails": [
          {
            "text": ""
          },
          {
            "text": ""
          },
          {
            "text": ""
          },
          {
            "text": ""
          },
          {
            "text": ""
          }
        ]
      },
      {
        "noteStatement": "Optional but may be worthwhile:",
        "textDetails": [
          {
            "text": ""
          },
          {
            "text": ""
          },
          {
            "text": ""
          },
          {
            "text": ""
          },
          {
            "text": ""
          }
        ]
      }
    ];
  }

  removeUnwantedDetailsFromContentData() {
    this.contentData.details.forEach(detail => {
      // detail.textDetails.forEach((textDetail, index) => {
      //   if(!textDetail.text) {
      // tempIndex = index;
      let tempIndex = detail.textDetails.findIndex(elem => !elem.text);
      if(tempIndex !== -1) {
        detail.textDetails.splice(tempIndex, this.getNumberOfItemsTodelete(tempIndex, detail.textDetails.length));
      }
      //   }
      // });
    });
  }

  getNumberOfItemsTodelete(index, arrLength) {
    if (index === arrLength - 1) {
      return 1;
    } else if (index < arrLength - 1) {
      return arrLength - index;
    }
  }
  
  handlePDFDetails() {
    // tslint:disable-next-line: max-line-length
    this.analyticsService.eventTrack({type: 'Download', name: this.contentData.checkList.name, pageID: this.utilService.getCurrentScreenName()});
    window.open(this.contentData.checkList.url, '_blank');
  }
  /** End of code block for CMS */
}
